"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _OrganisationDetails = _interopRequireDefault(require("./OrganisationDetails"));

var _UserDetails = _interopRequireDefault(require("./UserDetails"));

var _Actions = _interopRequireDefault(require("./Actions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ListItem(_ref) {
  var organisation = _ref.organisation,
      onClick = _ref.onClick,
      containerSize = _ref.containerSize,
      actionOptions = _ref.actionOptions;
  var organisationId = organisation.organisationId,
      subPackage = organisation.package,
      defaultUser = organisation.defaultUser,
      imageUrl = organisation.imageUrl,
      invitedUserEmail = organisation.invitedUserEmail;
  var containerWidth = containerSize.width;
  var small = _vars.NUMERIC_MEDIA_SIZES.small,
      medium = _vars.NUMERIC_MEDIA_SIZES.medium;
  var isSmall = containerWidth < small;
  var isMedium = containerWidth < medium;
  return _react.default.createElement(_uiKit.List.ListItem, {
    defaultImage: imageUrl,
    onClick: onClick,
    actionPopupOptions: actionOptions
  }, !isSmall && _react.default.createElement(_OrganisationDetails.default, {
    organisation: organisation
  }), !isMedium && _react.default.createElement(_UserDetails.default, {
    user: defaultUser,
    email: invitedUserEmail
  }), !isSmall && _react.default.createElement(_Actions.default, {
    subPackage: subPackage,
    organisationId: organisationId
  }), isSmall && _react.default.createElement("div", {
    className: "organisations__list-item--mobile"
  }, _react.default.createElement(_OrganisationDetails.default, {
    organisation: organisation,
    smallContainer: isSmall
  }), _react.default.createElement(_Actions.default, {
    subPackage: subPackage,
    organisationId: organisationId,
    smallContainer: isSmall
  })));
}

var _default = (0, _react.memo)(ListItem);

exports.default = _default;